<template>
    <base-input label="IVR"
    >

        <el-autocomplete
                style="display:block;"
                v-if="hasIVRs"
                v-model="ivr"
                :fetch-suggestions="querySearch"
                placeholder="Search IVR's"
                :clearable="true"
                @clear="handleClear()"
                @select="handleSelect"
        ></el-autocomplete>
        <small  v-if="hasIVRs" slot="helperText" id="nameHelp" class="form-text text-muted">
            These are all your IVR's (Virtual Receptionists)
        </small>
        <span v-if="!hasIVRs">You have no IVRs, you can create one <router-link
                to="/ivrs">here</router-link></span>
    </base-input>
</template>

<script>
    import {mapFields} from "vuex-map-fields";

    export default {
        name: "IVRSelector",
        props: {
            initialIVR: {
                type: String,
                default: '',
            },
        },
        computed: {
            ...mapFields('ivr', ['ivrs']),
            hasIVRs: function () {
                if (this.$store.getters['ivr/isLoading']) {
                    return true;
                }
                return this.ivrs.length > 0;
            },
        },
        data() {
            return {
                ivr: this.initialIVR,
            }
        },
        methods: {
            querySearch(queryString, cb) {
                let ivrs = this.ivrs;
                let results = queryString ? ivrs.filter(this.createFilter(queryString)).map(s => {
                    let name = s.name;
                    return {name: name, value: s.name}
                }) : ivrs.map(s => {
                    let name = s.name;
                    return {name: name, value: s.name}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (ivr) => {
                    let nameExists = ivr.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
                    return (nameExists);
                };
            },
            handleSelect(ivr) {
                let name = ivr.name;
                this.$emit('update', {name});
            },
            handleClear() {
                let name = null;
                this.$emit('update', {name});
            }
        },
        mounted() {
            if (this.$store.getters['ivr/needUpdate']) {
                this.$store.dispatch('ivr/load');
            }
        }
    }
</script>

<style scoped>

</style>